


export class BrowserAppEvaluationToolInfo {

  public version = '2024.6.19.2';

  constructor() {
  }

}
